export default "https://msvcweuwebsiteprod.blob.core.windows.net/bundles/frontend/dist/wolf/images/video-poster.8c7ab84a.jpg";